import { observer } from 'mobx-react';
import { FC } from 'react';
import { mdfAndExclModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate } from 'src/utils/helpers';
import ModalActionButton from 'src/view/components/Controls/Modal/ModalActionButton/ModalActionButton';

const ModifierAndExclusionModalHeaderControls: FC = observer((): JSX.Element | null => {
  const { isMulti, isSelectedCrumb, currentSectionSelectedItems, isSelectOnlyOneItemAvailable } = mdfAndExclModalStore;

  if (isMulti && !isSelectOnlyOneItemAvailable) {
    return (
      <div className="d-flex flex-row gap-20">
        {isSelectedCrumb ? null : <ModalActionButton title={localeStore.t('select_all')} onClick={mdfAndExclModalStore.selectAll} />}
        <ModalActionButton title={localeStore.t('deselect_all')} onClick={mdfAndExclModalStore.deselectAll} />
      </div>
    );
  }

  if (currentSectionSelectedItems.length) {
    return (
      <div className="d-flex flex-row align-items-center">
        <p className="family-medium text-size-14">{localeStore.t('selected')}</p>
        <p className="custom-modal-header-selected-item-title family-semibold text-size-14 mx-3">
          {getTranslate(currentSectionSelectedItems[0].name)}
        </p>
        <ModalActionButton title={localeStore.t('deselect')} onClick={mdfAndExclModalStore.deselectAll} type="some" />
      </div>
    );
  }

  return null;
});

export default ModifierAndExclusionModalHeaderControls;
